import axios from "axios";
import moment from "moment";
const _BASE_URL = "https://freshgroundapps-payment-server.herokuapp.com";

export const postRequest = (path, data) => {
  return axios.post(`${_BASE_URL}${path}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getRequest = (path) => {
  return axios.get(`${_BASE_URL}${path}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getFormattedDate = (date) => {
  return moment(new Date(date)).format("yyyy-MM-DD");
};

export const getWeekDayAsNumber = (date) => {
  return moment(new Date(date)).isoWeekday();
};

export const getIntervals = (startTime, endTime, int) => {
  const options = { hour: "2-digit", minute: "2-digit", hour12: true };
  let start = new Date("1970-01-01 " + startTime);
  let end = new Date(
    `1970-01-${startTime === endTime ? "02" : "01"} ${endTime}`
  );
  console.log(
    new Date(`1970-01-${startTime === endTime ? "02" : "01"} ${endTime}`)
  );

  let diff = (end - start) / 1000 / 60; // difference in minutes
  let hours = [];

  if (diff < int) {
    return [];
  }

  diff = diff - (diff % int);

  for (let i = 0; i < diff; i += int) {
    let currStart = new Date(start.getTime() + i * 60 * 1000);
    let currEnd = new Date(start.getTime() + (i + int) * 60 * 1000);
    console.log(currStart, currEnd);
    hours.push({
      startTime: currStart.toLocaleTimeString("en-US", options),
      endTime: currEnd.toLocaleTimeString("en-US", options),
    });
  }

  return hours;
};

export const getTimeFromDate = (time) => {
  return moment(new Date(time)).format("hh:mm a");
};
